// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3C1Mr","name":"Header_name__2onQn","birthday":"Header_birthday__3pvYt","skeleton":"Header_skeleton___kfOx"};